import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/aciair/conveyance'
import pathMap from 'src/paths/pathMap'

class ConveyanceRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.CONVEYANCE_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.CONVEYANCE_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.CONVEYANCE_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.CONVEYANCE_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default ConveyanceRoute
